import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const CasinoIcon = observer(
    'CasinoIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            fill='none'
            width='28'
            height='28'
            viewBox='0 0 28 28'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                stroke='#E4E4E7'
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M14 19.833a5.833 5.833 0 1 1-11.667 0c0-3.22 2.917-5.833 5.834-3.5m5.833 3.5c0-3.22-2.917-5.833-5.833-3.5m5.833 3.5a5.833 5.833 0 1 0 11.667 0c0-3.22-2.917-5.833-5.834-3.5M14 19.833c0-3.22 2.917-5.833 5.833-3.5m-11.666 0c3.756-3.395 5.005-10.208 5.833-14m5.833 14c-.07-3.5-3.896-11.223-5.833-14m0 0c3.337 5.449 6.662 8.167 11.667 8.167 0-2.718-5.005-8.167-11.667-8.167Z'
            />
        </SvgElement>
    )
);
